<script>
/**
 * Component: Packages: Summary
 *
 * @author PH
 */
export default {
  props: ["groups", "fields", "settings"],

  data: function() {
    return {
      currency: "$",
      tier: null,
      chappell_pt: null
    };
  },

  created: function() {
    // Set currency based on the settings.
    if (this.settings.currency) {
      this.currency = this.settings.currency;
    }
  },

  computed: {
    l18n: function() {
      return this.$store.getters.getSectionData("packages", "l18n");
    }
  },

  methods: {
    /**
     * Get: Summary
     *
     * Function calculates the summary price based on group ID.
     * If the groupID is empty, the function calculates summary
     * of all fields. In the other case the function calculates
     * summary only for the specific group.
     *
     * Each field has group id created with this structure:
     * {group}[{subgroup}] (e.g. own[profile-search]). That's why
     * the correct field detection uses '[' concatenation for
     * calculating the group summary.
     *
     * @param string|null groupID Group ID.
     * @author PH
     * @return number
     */
    getSummary(groupID) {
      let summary = 0;

      if (this.fields) {
        this.fields.forEach(field => {
          if (
            field.value &&
            field.settings.price &&
            "number" === typeof field.settings.price
          ) {
            if (!groupID || -1 !== field.group.indexOf(groupID + "[")) {
              summary += field.settings.price;
            }
          }
        });
      }

      return (Math.round(summary * 100) / 100).toFixed(2);
    }
  }
};
</script>

<template>
  <div class="signup-packages-summary">
    <div class="signup-packages-summary__title">
      <h3>{{ l18n.summary.title }}</h3>
    </div>

    <div class="signup-packages-summary__items">
      <div
        class="signup-packages-summary__item signup-packages-summary__item--package"
        v-for="group in groups"
        v-bind:key="group.id"
      >
        <div v-if="group.visible">
          <div class="signup-packages-summary__item-title">
            {{ group.title }}
          </div>
          <div class="signup-packages-summary__item-price">
            {{ currency }}{{ getSummary(group.id) }}
          </div>
        </div>
      </div>

      <div
        class="signup-packages-summary__item signup-packages-summary__item--summary"
      >
        <div>
          <div class="signup-packages-summary__item-title">
            {{ l18n.summary.total }}
          </div>
          <div class="signup-packages-summary__item-price">
            {{ currency }}{{ getSummary() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
